export default __webpack_public_path__ + "static/media/mapLeftWood.d35348d1.png";